const card = "rounded-xl border bg-card p-4 sm:p-6 border-border shadow-sm";

const detailGrid = "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3";

const detailRow = "flex items-start gap-3";
const detailIcon = "h-5 w-5 text-muted-foreground/70 shrink-0 mt-0.5";
const detailLabel = "text-sm font-medium text-muted-foreground";

const statusBadgeWrapper = "mt-1";

const copyableWrap = "inline-flex items-center gap-1.5";

const copyButton =
  "inline-flex items-center justify-center rounded-md p-1 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus:outline-none focus:ring-2 focus:ring-ring/50";

const copyIcon = "h-3.5 w-3.5";

const copiedHint = "text-xs text-success";

const section = "mt-4 rounded-xl border border-border bg-muted/30 p-4";

const sectionTitle = "mb-4 text-sm font-semibold uppercase tracking-wide text-muted-foreground";

const valueRow = "flex items-baseline justify-between gap-3 py-1.5";

const valueRowLabel = "text-sm text-muted-foreground";

const valueRowValue = "text-sm font-medium text-foreground text-right break-words";

const flagRow = "mt-2 flex flex-wrap gap-2";

const flagChip = "inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-2.5 py-1 text-xs font-medium text-foreground";

const flagChipMuted = "text-muted-foreground";

const flagChipWarning = "text-warning";

const neighborGrid = "grid grid-cols-1 gap-3 sm:grid-cols-2";

const neighborLink =
  "flex items-center justify-between gap-3 rounded-lg border border-border bg-background p-3 text-left transition-colors hover:bg-accent";

const neighborEmpty = "rounded-lg border border-dashed border-border p-3 text-sm text-muted-foreground";

const neighborAmount = "flex items-center gap-2";

const neighborLabel = "text-xs text-muted-foreground";

const timeline = "flex flex-col";

const timelineItem = "relative flex gap-3 pb-4 last:pb-0";

const timelineMarker = "relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full";

const timelineMarkerIcon = "h-4 w-4";

const attemptSuccess = "bg-success/15 text-success";
const attemptFailure = "bg-destructive/15 text-destructive";
const attemptPending = "bg-warning/15 text-warning";

const timelineBody = "min-w-0 flex-1";

const timelineHeader = "flex flex-wrap items-center justify-between gap-2";

const timelineMeta = "mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-muted-foreground";

const attemptError = "mt-2 flex items-start gap-1.5 rounded-md bg-destructive/10 px-2 py-1.5 text-xs text-destructive";

const attemptErrorIcon = "mt-0.5 h-3.5 w-3.5 shrink-0";

const emptyPanel = "flex flex-col items-center gap-2 rounded-lg border border-dashed border-border p-6 text-center";

const emptyPanelIcon = "h-6 w-6 text-muted-foreground/60";

const buttonGroup = "mt-6 flex flex-wrap gap-3";

const primaryButton =
  "inline-flex items-center gap-2 rounded-lg border border-transparent bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90 transition-colors";

const secondaryButton =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-5 py-2.5 text-sm font-medium text-foreground shadow-sm hover:bg-accent hover:text-accent-foreground transition-colors";

const destructiveButton =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-transparent bg-destructive px-5 py-2.5 text-sm font-medium text-destructive-foreground shadow-sm hover:bg-destructive/90 transition-colors";

const confirmButtonGroup = "mt-6 flex flex-wrap justify-end gap-3";

const loadingSkeleton = "h-8 w-48 animate-pulse rounded-lg bg-muted";

export {
  card,
  detailGrid,
  detailRow,
  detailIcon,
  detailLabel,
  statusBadgeWrapper,
  copyableWrap,
  copyButton,
  copyIcon,
  copiedHint,
  section,
  sectionTitle,
  valueRow,
  valueRowLabel,
  valueRowValue,
  flagRow,
  flagChip,
  flagChipMuted,
  flagChipWarning,
  neighborGrid,
  neighborLink,
  neighborEmpty,
  neighborAmount,
  neighborLabel,
  timeline,
  timelineItem,
  timelineMarker,
  timelineMarkerIcon,
  attemptSuccess,
  attemptFailure,
  attemptPending,
  timelineBody,
  timelineHeader,
  timelineMeta,
  attemptError,
  attemptErrorIcon,
  emptyPanel,
  emptyPanelIcon,
  buttonGroup,
  primaryButton,
  secondaryButton,
  destructiveButton,
  confirmButtonGroup,
  loadingSkeleton,
};
